"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The DateiBase model module.
 * @module model/DateiBase
 * @version 0.0.1
 */
class DateiBase {
  /**
   * Constructs a new <code>DateiBase</code>.
   * @alias module:model/DateiBase
   */
  constructor() {
    DateiBase.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>DateiBase</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DateiBase} obj Optional instance to populate.
   * @return {module:model/DateiBase} The populated <code>DateiBase</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DateiBase();
      if (data.hasOwnProperty('ort')) {
        obj['ort'] = _ApiClient.default.convertToType(data['ort'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>DateiBase</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DateiBase</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['ort'] && !(typeof data['ort'] === 'string' || data['ort'] instanceof String)) {
      throw new Error("Expected the field `ort` to be a primitive type in the JSON string but got " + data['ort']);
    }
    return true;
  }
}

/**
 * @member {String} ort
 */
DateiBase.prototype['ort'] = undefined;
var _default = exports.default = DateiBase;